import { MatConfigurationSidebar, MatDynamicRenderer } from "@/components/Mat";
import { OnboardingProgression } from "@/components/OnboardingProgression";
import Shimmer from "@/components/Shimmer";
import { HeaderTextBlock, TypographyContainer } from "@/components/Typography";
import { useOnboardingStatus } from "@/hooks/useOnboardingStatus";
import { useMatIntegrationConfiguration } from "@/requests/hooks/mat";
import { stringToTitleCaseWithUnderscore } from "@/utils/stringToTitleCase";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

const MatConfiguration = () => {
  const { integration } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    data: matIntegrationConfigurationData,
    isLoading: isMatIntegrationConfigurationLoading,
    isError: isMatIntegrationConfigurationError,
  } = useMatIntegrationConfiguration(integration!);
  const {
    onboardingStatus: { isOnboarding },
  } = useOnboardingStatus();

  if (isMatIntegrationConfigurationError) {
    navigate("/integrations/mat-settings?message=configuration_error");
    return;
  }

  const renderOnboardingProgression = () =>
    !!isOnboarding && (
      <div className="my-50">
        <OnboardingProgression currentStep="CONFIGURE_MAT_APP" enabled={true} />
      </div>
    );

  return (
    <>
      <TypographyContainer>
        <HeaderTextBlock
          featureText={t(
            "integrations.matSettings.configuration.header.feature",
          )}
          headingText={t(
            "integrations.matSettings.configuration.header.heading",
            { integration: stringToTitleCaseWithUnderscore(integration) },
          )}
        />
      </TypographyContainer>
      <div className="flex flex-row gap-30">
        <div className="hidden w-[200px] flex-shrink-0 sm:flex">
          {isMatIntegrationConfigurationLoading ? (
            <Shimmer height={100} />
          ) : (
            <MatConfigurationSidebar data={matIntegrationConfigurationData!} />
          )}
        </div>
        <div className="flex-grow">
          {isMatIntegrationConfigurationLoading ? (
            <Shimmer height={500} />
          ) : (
            <>
              <MatDynamicRenderer data={matIntegrationConfigurationData!} />
              {renderOnboardingProgression()}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default MatConfiguration;
